import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import { checkinprogressrecords } from "../../clients/CheckInprogressService";
import { runautomation } from "../../clients/RunScenarioService";
import { selectUser } from "../../redux/slices/userSlice";
import CountryCodedata from "../../types/CountryCodedata";
import {
  MenuItem,
  Select,
  TextField,
  FormControl,
  Box,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Chip,
  Autocomplete,
  FormHelperText,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useInterval } from "../../utils/useInterval";

const Configtest: React.FC<{}> = () => {
  const user = useSelector(selectUser);
  const [tags, setTags] = useState<string>("");
  const [jobDescription, setJobdescription] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [testDataFiles, setTestDataFiles] = useState<File[] | null>(null);
  const [featurefiles, setFeaturefiles] = useState<File[] | null>(null);
  const [countrycode, setCountryCode] = useState<string>("UK");
  const [dockerstatus, setDockerStatus] = useState<boolean>(false);
  const filesList = testDataFiles ? [...testDataFiles] : [];
  const [error, setError] = useState<string>("");
  const featurefilesList = featurefiles ? [...featurefiles] : [];
  const [loading, setLoading] = useState<boolean>(false);
  const formData = new FormData();
  const navigate = useNavigate();

  const [emails, setEmails] = useState<string[]>([]);

  const [isValidTag, setIsValidTag] = useState<boolean>(true);

  const checkInprogressRecords = async () => {
    try {
      setLoading(true);
      const InprogressRecordsResponse = await checkinprogressrecords(
        user.auth,
        user.username
      );
      if (InprogressRecordsResponse.ok) {
        const data = await InprogressRecordsResponse.json();
        setDockerStatus(data.dockerStatus);
      } else {
        const error = await InprogressRecordsResponse.json();
        toast.error("Error: " + error.error);
      }
    } catch (e) {
      console.log("Inpogress records", e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    checkInprogressRecords();
  }, []);

  useInterval(
    () => {
      if (!dockerstatus) {
        checkInprogressRecords();
      }
    },
    parseInt(process.env.REFRESH_INTERVAL ?? "60000", 10)
  );

  const handleFiles = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(e.target.files || []);
    setTestDataFiles(selectedFiles);
  };
  const handlefeatureFiles = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = Array.from(e.target.files || []);
    setFeaturefiles(selectedFiles);
  };

  const runJob = async (e: FormEvent) => {
    e.preventDefault();
    if (emails.length === 0) {
      setIsValidTag(false);
      setError("Please enter at least one email.");
      return;
    }
    setLoading(true);
    setDockerStatus(false);
    formData.append("email", "'" + emails.join(",") + "'");
    formData.append("countryCode", countrycode);
    formData.append(
      "jobDescription",
      jobDescription.length > 0 ? "'" + jobDescription + "'" : ""
    );
    formData.append("username", user.username);
    formData.append("tags", "'" + tags + "'");
    filesList.forEach((file, index) => {
      formData.append("testDataFiles", file);
    });
    featurefilesList.forEach((file, index) => {
      formData.append("featureFiles", file);
    });

    try {
      const response = await runautomation(user.auth, formData);
      const runresponse = await response.json();
      if (response.ok) {
        if (runresponse.containerId !== "NoContainer") {
          toast.success("TestSuite Configured successfully");
          navigate("/reports");
        } else if (runresponse.containerId === "NoContainer") {
          toast.error("TestSuite Configuration Failed");
          setDockerStatus(false);
        }
      } else {
        toast.error("TestSuite Configuration Failed");
        setDockerStatus(false);
      }
    } catch (error) {
      toast.error("TestSuite Configuration Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsValidTag(true);
    setError("");
    setEmail(e.target.value);
  };

  const removeEmailChip = (index: number) => {
    setEmails(emails.filter((_, i) => i !== index));
    setEmail("");
  };

  const handleKeyDown = (
    evt: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (
      evt.key === "Enter" &&
      email.trim() !== "" &&
      email.length > 0 &&
      email.trim() !== "/n"
    ) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setIsValidTag(emailPattern.test(email));
      if (!emailPattern.test(email)) {
        setError("Invalid email found");
      } else {
        if (emails.includes(email)) {
          setError("Email already present");
          return;
        }
        setEmails([...emails, email]);
        setError("");
      }
    } else if (evt.key === "Enter" && emails.length === 0) {
      setIsValidTag(false);
      setError("Please enter at least one email.");
    }
    setEmail("");
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <CircularProgress disableShrink />
      </Box>
    );
  }
  return (
    <>
      <form
        onSubmit={runJob}
        encType="multipart/form-data"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "30px",
        }}
      >
        <Paper
          square={false}
          elevation={4}
          sx={{
            padding: "1.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100vh",
            gap: "9px",
          }}
        >
          <Typography
            variant="h4"
            mb={1}
            fontSize={"25px"}
          >
            Configure Job
          </Typography>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
              flexGrow={1}
            >
              Email*:
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  aliginContent: "center",
                  justifyContent: "center",
                  flexGrow: 1,
                  border: "1px solid #ADADAD",
                  borderRadius: "4px",
                  // height: "40px",
                }}
              >
                {/* <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={emails}
                  size="small"
                  sx={{
                    flexWrap: "nowrap",
                    " & .MuiAutocomplete-inputRoot": {
                      flexWrap: "nowrap",
                    },
                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                      paddingBottom: "0px",
                      paddingTop: "0px",
                      paddingLeft: "0px",
                    },
                    "& .MuiOutlinedInput-root": {
                      minWidth: "100%",
                      width: "max-content",
                      borderColor: "white",
                      padding: "0px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&.Mui-focused": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        border: "none",
                      },

                      "&:hover": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },

                        "&:after": {
                          border: "none",
                        },
                      },
                    },
                  }}
                  disableClearable
                  renderTags={(value) => (
                    <div
                      style={{
                        display: "flex",
                        gap: 0.5,
                        border: "none",
                      }}
                    >
                      {value.map((stringEmail, stringEmailIndex) => (
                        <Chip
                          key={stringEmailIndex}
                          label={stringEmail}
                          sx={{}}
                          onDelete={() => removeEmailChip(stringEmailIndex)}
                        />
                      ))}
                    </div>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="email"
                      size="small"
                      sx={{
                        flexWrap: "nowrap",
                        maxWidth: "470px",
                        overflowX: "auto",
                        borderRadius: "4px",
                        padding: "5px",
                        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
                          width: "max-content",
                        },
                      }}
                      // multiline
                      // maxRows={2}
                      placeholder="Enter your Email Id"
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                        handleKeyDown(e)
                      }
                      onChange={handleEmailChange}
                      error={!isValidTag}
                    />
                  )}
                /> */}

                {/* vertical scroll */}

                <Autocomplete
                  multiple
                  freeSolo
                  options={[]}
                  value={emails}
                  size="small"
                  sx={{
                    flexWrap: "wrap",
                    " & .MuiAutocomplete-inputRoot": {
                      flexWrap: "wrap",
                    },
                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                      paddingBottom: "0px",
                      paddingTop: "0px",
                      paddingLeft: "0px",
                    },
                    "& .MuiOutlinedInput-root": {
                      height: "max-content",
                      borderColor: "white",
                      padding: "0px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      "&.Mui-focused": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        border: "none",
                      },

                      "&:hover": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },

                        "&:after": {
                          border: "none",
                        },
                      },
                    },
                  }}
                  disableClearable
                  renderTags={(value) => (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-start",
                        columnGap: "0.5rem",
                        rowGap: "0.3rem",
                        border: "none",
                      }}
                    >
                      {value.map((stringEmail, stringEmailIndex) => (
                        <Chip
                          key={stringEmailIndex}
                          label={stringEmail}
                          sx={{}}
                          onDelete={() => removeEmailChip(stringEmailIndex)}
                        />
                      ))}
                    </div>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="email"
                      size="small"
                      sx={{
                        flexWrap: "wrap",
                        maxHeight: "80px",
                        minHeight: "fit-content",
                        overflowY: "auto",
                        borderRadius: "4px",
                        padding: "5px",
                        "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
                          height: "max-content",
                          width: "max-content",
                          marginTop: "3px",
                          marginBottom: "2px",
                        },
                      }}
                      // multiline
                      // maxRows={2}
                      placeholder="Enter your Email Id"
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
                        handleKeyDown(e)
                      }
                      onChange={handleEmailChange}
                      error={!isValidTag}
                    />
                  )}
                />
              </Box>
              {error && <FormHelperText error>{error}</FormHelperText>}
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
            >
              Tags*:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                aliginContent: "center",
                justifyContent: "center",
              }}
            >
              <TextField
                size="small"
                required
                id="Tags"
                value={tags}
                placeholder="Job Scenario Tags"
                onBlur={(e: any) => {
                  const newValue = e.target.value.replace(
                    /\b(?<!@)\w+\b(?!@)/g,
                    (match: string) => match.toLowerCase()
                  );
                  setTags(newValue);
                }}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setTags(e.target.value);
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
            >
              Job Description:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                aliginContent: "center",
                justifyContent: "center",
              }}
            >
              <TextField
                size="small"
                id="jobdescription"
                InputProps={{
                  inputProps: {
                    maxLength: 60,
                  },
                }}
                value={jobDescription}
                placeholder="Enter your Job Details"
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setJobdescription(e.target.value)
                }
              />
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
            >
              Organization*:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                aliginContent: "center",
                justifyContent: "center",
              }}
            >
              <FormControl>
                <Select
                  size="small"
                  required
                  id="orgcode"
                  value={countrycode}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                    justifyContent: "center",
                    "& .MuiSelect-root": {
                      alignSelf: "flex-start",
                    },
                  }}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  {CountryCodedata.map((org: string) => (
                    <MenuItem
                      key={org}
                      value={org}
                    >
                      {org}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
            >
              Data Files:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                aliginContent: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="outlined"
                size="small"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  border: "1px solid #fe948f",
                }}
              >
                <CloudUploadIcon
                  color="secondary"
                  sx={{
                    color: "#fe948f",
                    aliginItems: "center",
                    fontSize: 30,
                    ml: "20%",
                  }}
                />
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  ml={"2%"}
                >
                  Upload Test Data files
                </Box>
                <input
                  type="file"
                  name="files"
                  id="testfiles"
                  accept=".json"
                  multiple
                  onChange={handleFiles}
                  style={{
                    display: "block",
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    opacity: 0,
                    cursor: "pointer",
                  }}
                />
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "10px",
              flexGrow: 1,
            }}
          >
            <Typography
              variant="h6"
              fontSize={"18px"}
              fontWeight={"medium"}
              alignItems={"center"}
              width={"40%"}
              justifyContent={"left"}
              text-align={"right"}
              sx={{ float: "left" }}
            >
              FeatureFiles:
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                aliginContent: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="text"
                size="small"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  border: "1px solid #fe948f",
                }}
              >
                <CloudUploadIcon
                  color="secondary"
                  sx={{ color: "#fe948f", fontSize: 30, ml: "20%" }}
                />
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"flex-start"}
                  ml={"2%"}
                >
                  Upload Feature files
                </Box>
                <input
                  type="file"
                  name="featurefiles"
                  id="featurefiles"
                  accept=".feature"
                  multiple
                  onChange={handlefeatureFiles}
                  style={{
                    display: "block",
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    opacity: 0,
                    cursor: "pointer",
                  }}
                />
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              flexGrow: 1,
            }}
          >
            <Button
              size="small"
              type="submit"
              disabled={!dockerstatus}
            >
              Run Job
            </Button>
          </Box>
        </Paper>
      </form>
      <ToastContainer position="bottom-left" />
    </>
  );
};
export default Configtest;
